import { isOnServer } from '../generalUtils'

export const getCookieClient = (name: string): string | undefined => {
	return document.cookie
		.split('; ')
		.find((row) => row.startsWith(`${name}=`))
		?.split('=')[1]
}

export const getAllCookiesClient = (): Record<string, string> => {
	return document.cookie.split('; ').reduce(
		(acc, cookie) => {
			const [key, value] = cookie.split('=')
			if (key && value) {
				acc[key] = value
			}
			return acc
		},
		{} as Record<string, string>,
	)
}

export const setCookieClient = (
	name: string,
	value: string,
	options: {
		expires?: Date | number
		days?: number
		path?: string
		secure?: boolean
		sameSite?: 'Strict' | 'Lax' | 'None'
	} = {},
): void => {
	const { days = 0, path = '/', secure = false, sameSite = 'Lax' } = options

	const expires = options.expires ? new Date(options.expires) : new Date()
	expires.setDate(expires.getDate() + days)

	document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=${path}; ${
		secure ? 'secure; ' : ''
	}SameSite=${sameSite}`
}

export const deleteCookieClient = (name: string, path = '/'): void => {
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`
}

export const getCookieIsomorphic = async (
	name: string,
): Promise<string | undefined> => {
	if (isOnServer) {
		const { cookies } = await import('next/headers')
		return (await cookies()).get(name)?.value
	} else {
		return getCookieClient(name)
	}
}
